// extracted by mini-css-extract-plugin
export default {"container":"k5CGeYqVXb7JL6lvYGu6"};